export let Roles = {
    Administrators: 'Administrators',
    HelpDesk: 'Help Desk',
    OpHelpDesk: 'Operative Help Desk',
    FinanceOffice: 'Finance Office',
    Lab: 'Lab',
    Operations: 'Operations',
    Sales: 'Sales',
    Disabled: 'Disabled'
  }